// extracted by mini-css-extract-plugin
module.exports = {"gamesList":"gameslist_gamesList__lexCP"};